<template>
    <b-modal id="register-privacy-agree"
             :title="$t(`개인정보 제공 동의`)"
             size="lg"
             no-close-on-backdrop
             no-close-on-esc
             hide-footer
    >
        <div class="pt-3 mb-4 gray-900">
            {{
                $t(`(주)퀀티파이드이에스지는 ESG 실사 또는 평가(이하 '평가'), 평가 점수 산출, 평가 결과보고서 발급, 평가 참여 이력 관리 등 서비스 제공을 위해 아래와 같이 개인정보를 수집 및 이용하고자 합니다.`)
            }}
        </div>
        <b-table-simple class="regular-table">
            <b-thead>
                <b-tr>
                    <b-td> {{ $t(`항목`) }}</b-td>
                    <b-td> {{ $t(`수집목적`) }}</b-td>
                    <b-td> {{ $t(`보유기간`) }}</b-td>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr>
                    <b-td> {{ $t(`성함, 이메일주소, 연락처`) }}</b-td>
                    <b-td> {{ $t(`ESG 실사 또는 평가(이하 '평가'), 평가 결과보고서 발급, 평가 참여 이력 관리 등 서비스 제공`) }}</b-td>
                    <b-td> {{ $t(`3년`) }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <a :href="$i18n.locale === 'ko' ? 'https://qesg.co.kr/terms/privacy_policy/' : 'https://qesg.co.kr/terms/privacy_policy_en/'" target="_blank">
            {{ $t(`(주)퀀티파이드이에스지 개인정보처리방침 전문 보기`) }}
        </a>

        <div class="pt-5 mb-4 f-95">
            {{ $t(`※ 위의 개인정보 수집‧이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 ESG 실사 또는 평가 참여 제한 등의 불이익이 발생하게 됩니다.`) }}
        </div>

        <b-form-checkbox v-model="checked" class="blue-check text-right" @change="changeChecked"> {{
                $t(`위와 같이 개인정보를 수집·이용하는데 동의합니다.`)
            }}
        </b-form-checkbox>

        <div class="text-right pt-4">
            <b-button variant="blue" @click.stop.prevent="handleNext"> {{ $t(`확인`) }}</b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'PrivacyAgree',
    model: {
        prop: 'privacy_agree',
        event: 'update:privacy_agree',
    },
    props: {
        privacy_agree: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            checked: false,
        };
    },
    methods: {
        changeChecked(){
            this.$emit('update:privacy_agree', this.checked);  
        },
        handleNext() {
            if(this.checked){
                this.$emit('goNext');
            }
            else {
                const h = this.$createElement;
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: this.$t('개인정보 제공 동의'),
                    message: h('div', {}, [
                        h('div', {}, this.$t('개인정보 제공 동의에 체크하지 않으셨습니다.')),
                        h('div', {}, this.$t('동의 후 다음 단계로 진행해주세요.'))
                    ]),
                });
            }
        }
    },
};
</script>

<style lang="scss" scoped>

</style>
